import req from './../../../fetch';
import { paramsToString, undocumentedResponse } from './../../../utils';

import {
  AllAPIResponses,
  CarbonError,
  CarbonAPIKeyType,
} from './../../../index';
type Params = {
  userId: number;
};

const get = async (
  params: Params,
  headers?: Headers
): Promise<AllAPIResponses<CarbonAPIKeyType[]>> => {
  try {
    const resp = await req.get(
      `/api/authentication/apikey${paramsToString(params)}`,
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: (await resp.json()) as CarbonAPIKeyType[],
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default get;
